<div class="chat-drawer">

  <!-- ── Delete confirmation popup ─────────────────────────────── -->
  <div *ngIf="showDeleteConfirm"
       class="chat-drawer__popup-overlay"
       role="alertdialog"
       [attr.aria-label]="'chatAi.drawer.deleteConfirmAriaLabel' | translate"
       (click)="onCancelDelete()">
    <div class="chat-drawer__popup" (click)="$event.stopPropagation()">
      <p class="chat-drawer__popup-msg">{{ 'chatAi.drawer.deleteConfirm' | translate }}</p>
      <div class="chat-drawer__popup-actions">
        <button type="button" class="chat-drawer__popup-btn"
                (click)="onCancelDelete()">
          {{ 'chatAi.drawer.deleteConfirmNo' | translate }}
        </button>
        <button type="button" class="chat-drawer__popup-btn chat-drawer__popup-btn--danger"
                (click)="onConfirmDelete()">
          {{ 'chatAi.drawer.deleteConfirmYes' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="chat-drawer__header">
    <button type="button" class="chat-drawer__action" (click)="onNewChat()"
            [attr.aria-label]="'chatAi.sidebar.newChat' | translate">
      + {{ 'chatAi.drawer.newChat' | translate }}
    </button>
    <button type="button"
            class="chat-drawer__close"
            (click)="onDeleteChat()"
            [attr.aria-label]="'chatAi.drawer.deleteChat' | translate"
            [title]="'chatAi.drawer.deleteChat' | translate">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <app-chat-suggestions *ngIf="messages.length === 0" (pick)="onSuggestionPick($event)" (navigate)="onNavigate($event)"></app-chat-suggestions>
  <app-chat-conversation [messages]="messages" (suggestionPick)="onSuggestionPick($event)"></app-chat-conversation>

  <!-- Reset context — subtle link below messages -->
  <div *ngIf="messages.length > 0" class="chat-drawer__reset">
    <button type="button" class="chat-drawer__reset-btn" (click)="onNewChat()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
        <path d="M3 3v5h5"/>
      </svg>
      {{ 'chatAi.drawer.resetContext' | translate }}
    </button>
  </div>

  <app-chat-input [busy]="busy" (send)="onSend($event)"></app-chat-input>
</div>
